<div class="drawer-menu-container">
	<div class="head">
		<div class="user-info">
			<img [src]="photourl" alt="user">
			<div class="info-text">
				<p class="small">{{ 'HEADER.LBL_WELCOME' | translate }}</p>
				<p class="text">{{User.fullName}}</p>
			</div>
		</div>
		<img src="assets/images/white-close.svg" alt="" class="close-drawer" (click)="closeDrawer()">
	</div>
	<ul>
		<!-- <li>
			<a (click)="openChild($event)">MASTER<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
		
				<ul class="child-menu">
					<li>
						<a (click)="openChild($event)">PACKAGE MANAGEMENT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
						<ul class="child-menu third-level">
							<li><a [routerLink]="['/API/subscriptionedit/new-subscription']">PACKAGE ADD</a></li>
							<li><a [routerLink]="['/API/subscription/subscription-list']">PACKAGE LIST</a></li>
						</ul>
					</li>
					<li>
						<a (click)="openChild($event)">FEATURE MANAGEMENT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
						<ul class="child-menu third-level">
							<li><a [routerLink]="['/API/featureedit/new-feature']">FEATURE ADD</a></li>
							<li><a [routerLink]="['/API/feature/feature-list']">FEATURE LIST</a></li>
						</ul>
					</li>
					<li>
						<a>RIGHT MANAGEMENT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
						<ul class="child-menu third-level">
							<li><a [routerLink]="['/API/rightedit/new-right']">RIGHT ADD</a></li>
							<li><a [routerLink]="['/API/rightsearch/right-summary']">SEARCH</a></li>
						</ul>
					</li>
					<li>
						<a (click)="openChild($event)">ROLE MANAGEMENT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
						<ul class="child-menu third-level">
							<li><a [routerLink]="['/API/roleedit/new-role']">ROLE ADD</a></li>
							<li><a [routerLink]="['/API/rolesearch/role-summary']">SEARCH</a></li>
						</ul>
					</li>
					<li>
						<a (click)="openChild($event)">PERMISSION FEATURE MANAGEMENT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
						<ul class="child-menu third-level">
							<li><a [routerLink]="['/API/permissionfeatureedit/new-permissionfeature']">PERMISSION FEATURE ADD</a></li>
							<li><a [routerLink]="['/API/permissionfeaturesearch/permissionfeature-summary']">SEARCH</a></li>
						</ul>
					</li>
					<li>
						<a (click)="openChild($event)">TENANT MANAGEMENT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
						<ul class="child-menu third-level">
							<li><a [routerLink]="['/API/tenantedit/new-tenant']">TENANT ADD</a></li>
							<li><a [routerLink]="['/API/tenantsearch/tenant-summary']">SEARCH</a></li>						
						</ul>
					</li>
				</ul>		
		</li>
		<li>
			<a (click)="openChild($event)">TENANT<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>		
				<ul class="child-menu">
					
						<li><a [routerLink]="['/API/subscribe']">SUBSCRIBE</a></li>
						<li><a [routerLink]="['/API/mysubscription']">MY SUBSCRIPTION</a></li>	
						<li><a [routerLink]="['/API/company/company-details']">TENANT ADMINISTRATION</a></li>							
												
				</ul>
			
		</li> -->
		<li class="side-navigation-parent">
			<a>

				<div class="my-input-group">
					<label for="">{{ 'HEADER.LBL_SERVICES' | translate }}</label>
					<div class="side-navigation-mobile-wrapper">
						<div class="side-navigation-mobile-container" (click)="toggleRightTypeData()">
							<img [src]="selectedRightType?.rightTypeFileName" alt="">
							<p>{{selectedRightType?.name}}</p>
							<img src="assets/images/dropdown-dark.svg" alt="">
						</div>
						<ul class="side-navigation-dropdown"  [ngClass]="{ 'active': showRightTypeList }">
							<li *ngFor="let userRightType of userRightTypeAccessList" (click)="changeRightType(userRightType)">
								<img [src]="userRightType.rightTypeFileName" alt="">
								<p>{{userRightType?.name}}</p>
							</li>
						</ul>
					</div>
				</div>
			</a>

		</li>






		<ng-container *ngFor="let subItem of rightdata, let i=index">
			<li *ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length>0">
				<a [routerLinkActive]="['active']" (click)="openChild($event)">{{subItem.titleName || subItem.menuName}}
					<img src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
				<ul class="child-menu">
					<ng-container *ngFor="let secondlevelItem of subItem.children">
						<li
							*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length>0">
							<a [routerLinkActive]="['active']"
								(click)="openChild($event)">{{secondlevelItem.titleName || secondlevelItem.menuName}}<img
									src="assets/images/grey-arrow.svg" alt="toggle" class="arrow"></a>
							<ul class="child-menu third-level">
								<ng-container *ngFor="let thirdlevelitem of secondlevelItem.children">
									<li><a [routerLinkActive]="['active']" (click)="GetMenuParentId(thirdlevelitem.id)"
										[routerLink]="[geturl(thirdlevelitem)]">{{thirdlevelitem.titleName || thirdlevelitem.menuName}}</a></li>
								</ng-container>
							</ul>
						</li>
						<li
							*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length==0">
							<a [routerLinkActive]="['active']" (click)="GetMenuParentId(thirdlevelitem.id)"
								[routerLink]="[geturl(secondlevelItem)]">{{secondlevelItem.titleName || secondlevelItem.menuName}}</a>
						</li>
					</ng-container>
				</ul>
			</li>
			<li *ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length==0">
				<a [routerLinkActive]="['active']" (click)="GetMenuParentId(thirdlevelitem.id)"
					[routerLink]="[geturl(subItem)]">{{subItem.titleName || subItem.menuName}}</a>
			</li>
		</ng-container>
		<li class="last">
			<ul>
				<li class="seperator theme-heading">{{'HEADER.LBL_APPEARANCE' | translate}}</li>
				<li class="theme-control">
					<div class="styled-radio-container">
						<input type="radio" class="styled-radio" id="test12" name="radio-group">
						<label for="test12">{{'HEADER.LBL_LIGHT_MODE' | translate}} <img src="assets/images/new-set/light-mode.svg" alt="" class="theme-icon"></label>
					</div>
				</li>
				<li class="theme-control last-control">
					<div class="styled-radio-container">
						<input type="radio" class="styled-radio" id="test2" name="radio-group">
						<label for="test2">{{'HEADER.LBL_DARK_MODE' | translate}}<img src="assets/images/new-set/dark-mode.svg" alt="" class="theme-icon"></label>
					</div>
				</li>
				<li *ngIf="isChangePasswordAccess"><a (click)="closeDrawer()" [routerLink]="['/changepassword']"><img src="assets/images/new-set/edit-dark.svg" alt="setting" class="icon"><span>{{ 'HEADER.LBL_CHANGEPASSWD' | translate }}</span></a></li>
				<li *ngIf="_userTypeId != _internalusertype"><a (click)="redirectToProfilePage()"><img
					src="assets/images/user.svg" alt="profile" class="icon">{{
				'USER_PROFILE.TITLE' | translate }}</a></li>
				<li (click)="signOut()"><a><img src="assets/images/logout.svg" alt="logout" class="icon"><span>{{ 'HEADER.LBL_SIGNOUT' | translate }}</span></a></li>
			</ul>
		</li>
		<!-- <li class="last"><a (click)="closeDrawer()" [routerLink]="['/api/changepassword']"><img src="assets/images/setting.svg" alt="setting" class="icon"><span>{{ 'HEADER.LBL_CHANGEPASSWD' | translate }}</span></a></li>
		<li (click)="signOut()" class="last"><a><img src="assets/images/logout.svg" alt="logout" class="icon"><span>{{ 'HEADER.LBL_SIGNOUT' | translate }}</span></a></li> -->
	</ul>
</div>